export type InspectUrlUpdates = {
    unitId?: string | null;
    action?: string | null;
};

export function buildInspectSearchParams(
    current: URLSearchParams,
    updates: InspectUrlUpdates,
): URLSearchParams {
    const next = new URLSearchParams(current);

    if (updates.unitId === null) {
        next.delete('unitId');
    } else if (updates.unitId) {
        next.set('unitId', updates.unitId);
    }

    if (updates.action === null) {
        next.delete('action');
    } else if (updates.action) {
        next.set('action', updates.action);
    }

    return next;
}
